import { Button } from "react-bootstrap";
import AuditStructureForm from "../../components/personal/PlaningAuditPage/AuditStructureForm";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import PlaningAuditBlock from "../../components/personal/PlaningAuditPage/PlaningAuditBlock";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const PlaningAuditPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Организовать аудит"}>
            <PlaningAuditBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default PlaningAuditPage;